import React from 'react';
import styles from './LoadingScreen.module.scss';

const LoadingScreen: React.FC = () => {
  return (
    <div className={styles['loading-screen']}>
      <div className={styles['logo-container']}>
        <div className={styles.glow} />
        <img
          src="https://cdn.silverclaw.eu/logo.png"
          alt="SilverClaw"
          className={styles.logo}
        />
      </div>
      <div className={styles['loading-bar']}>
        <div className={styles.bar} />
      </div>
      <p className={styles['loading-text']}>
        Loading<span className={styles.dots}>...</span>
      </p>
    </div>
  );
};

export default LoadingScreen;
